export const applyPageMeta = ({
  title,
  description,
  canonical,
  image = 'https://ticardoso.com.br/profile.jpg'
}) => {
  if (title) {
    document.title = title;
  }

  const ensureMeta = (attribute, value) => {
    let meta = document.querySelector(`meta[${attribute}="${value}"]`);
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute(attribute, value);
      document.head.appendChild(meta);
    }
    return meta;
  };

  if (description) {
    ensureMeta('name', 'description').setAttribute('content', description);
    ensureMeta('property', 'og:description').setAttribute('content', description);
    ensureMeta('name', 'twitter:description').setAttribute('content', description);
  }

  if (title) {
    ensureMeta('property', 'og:title').setAttribute('content', title);
    ensureMeta('name', 'twitter:title').setAttribute('content', title);
  }

  if (canonical) {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonical);
    ensureMeta('property', 'og:url').setAttribute('content', canonical);
    ensureMeta('name', 'twitter:url').setAttribute('content', canonical);
  }

  if (image) {
    ensureMeta('property', 'og:image').setAttribute('content', image);
    ensureMeta('name', 'twitter:image').setAttribute('content', image);
  }
};
